import React from 'react'
import Navbar from '../Common/Navbar'
import Header from './Header'
import { Footer } from '../Footer/Footer'
import Banner from '../Common/Banner'
import { BottomSecton } from '../Footer/BottomSecton'
import KWFDifference from './KwfDifference'
import ImpactStats from './ImpactStats'
import BetterTomorrow from './BetterTommorow'
import { Helmet } from 'react-helmet'
// import { AuthWrapper } from '../AuthWrapper'
const About = () => {
  return (
    // <AuthWrapper>
    <>
    <Helmet>
      <title>About Khadim Welfare Foundation | Serving Humanity with Care</title>
      <meta name="description" content='Discover how KWF works with compassion to support families in need through programmes in food, shelter, clothing, education and healthcare.'/>
    </Helmet>
    <Navbar/>
    <Banner title={'About Us'} text={`KWF - A Helping Hand for Humanity`}/>
    <BetterTomorrow/>
    <KWFDifference/>
    <ImpactStats/>
    <BottomSecton/>
    <Footer/>
    </>
    // </AuthWrapper>
  )
}

export default About